@if (
  {
    lineCheckResultsShown: lineCheckProductsService.lineCheckResultsShown$ | async,
    addressPrefill: lineCheckProductsService.addressPrefill$ | async,
    lineCheckResultsLoading: lineCheckProductsService.lineCheckResultsLoading$ | async,
    hasEligibleProduct: lineCheckProductsService.hasEligibleProduct$ | async,
  };
  as $
) {
  @if (!lineCheckFormsHidden()) {
    <div class="container margin-on-scroll" [id]="slice.sectionId">
      <div
        class="shadow-[0_2px_24px_rgba(0,0,0,0.1)] rounded-2xl bg-white border border-solid border-color-gray-4 px-4 pb-2 pt-12 m-4"
      >
        <lib-line-check-form
          id="form-address-tabpanel"
          role="tabpanel"
          (addressFormSubmitEvent)="onAddressFormSubmitEvent($event)"
          (addressFormReset)="onFormReset()"
          [addressPrefill]="$.addressPrefill"
          [addressLookupFields]="slice.addressLookupFields"
          [buttonText]="slice.button_text"
          [backButtonText]="slice.back_button_text"
          [lineCheckResultsShown]="$.lineCheckResultsShown"
          [lineCheckResultsLoading]="$.lineCheckResultsLoading"
        >
        </lib-line-check-form>
      </div>
      @if ($.lineCheckResultsShown && filteredProducts?.length) {
        <div class="p-4 m-4 margin-on-scroll" #lineCheckResultList>
          <app-line-check-result-list
            [slice]="slice"
            [products]="filteredProducts"
            [lineCheckEligibleAccess]="lineCheckEligibleAccess"
            [hasEligibleProduct]="$.hasEligibleProduct"
          >
          </app-line-check-result-list>
        </div>
      }
    </div>
  } @else {
    <lib-loading></lib-loading>
  }
}
